import { render, staticRenderFns } from "./RoleSelectionDialog.vue?vue&type=template&id=609375d8&scoped=true&"
import script from "./RoleSelectionDialog.vue?vue&type=script&lang=js&"
export * from "./RoleSelectionDialog.vue?vue&type=script&lang=js&"
import style0 from "./RoleSelectionDialog.vue?vue&type=style&index=0&id=609375d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609375d8",
  null
  
)

export default component.exports